const NOTIFICATION_LINK_SELECTOR = '[data-url], .download-link';

const getNotificationLinkFromTarget = (target: EventTarget | null): HTMLElement | null => {
  if (!(target instanceof Element)) return null;

  const linkElement = target.closest(NOTIFICATION_LINK_SELECTOR);
  return linkElement instanceof HTMLElement ? linkElement : null;
};

export { getNotificationLinkFromTarget };
